import Stomp from 'stompjs';
import SockJS from 'sockjs-client';
import axios from 'axios';

class MonitorService {

    constructor(props) {
        this.server = "/monitorservice/";
        this.stompClient = null;
        this.connected = false;
        let hostName = window.location.hostname;
        if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === "dev.andrei.io")
            this.server = "http://devomni.fidelitycloud.es:8090/monitorservice";//TRAMPA,
    }

    error = (e) => {
        if (e.response.status === 403) {
            const event = new Event('apiErrorForbidden');
            document.dispatchEvent(event);
        }
    }

    login = (data, callBack) => {
        axios.post(`${this.server}/api/login`, data)
            .then(res => {
                callBack(res);
            })
            .catch(e => {
                callBack(false);
                this.error(e);
            });
    }

    checktoken = (token, callBack) => {

        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${this.server}/api/checktoken`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                this.error(e);
            });
    }

    getSupervisedGroups = (token, callBack) => {
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${this.server}/api/getSupervisedGroups`,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                this.error(e);
            });
    }

    connect(token, callBack) {

        let socket = new SockJS(`${this.server}monitorweb?token=${token}`);
        this.stompClient = Stomp.over(socket);
        this.stompClient.heartbeat.outgoing = 10000;
        this.stompClient.heartbeat.incoming = 10000;
        this.stompClient.reconnect_delay = 5000;
        this.stompClient.debug = null;
        this.stompClient.connect({}, (frame) => {
            console.debug('Connected: ' + frame);
            this.connected = true;
            callBack(true);
        }, (error) => {
            this.connected = false;
            console.error('Connection error: ' + error);
            const event = new Event('wsConnectionLost');
            document.dispatchEvent(event);
            callBack(false);
        });
    }

    transferCallToAgent = (token, data, callBack) => {

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${this.server}/api/transferCallToAgent`,
            data: data,
            headers: {
                'Authorization': token
            }
        };

        axios.request(config)
            .then((res) => {
                callBack(res);
            })
            .catch((e) => {
                callBack(false);
                this.error(e);
            });
    }


}

const monitorService = new MonitorService();
export default monitorService;